'use client'

import { ErrorContent } from '@marketplace-web/error-display/error-display-feature'

// TODO: localise this
const title = 'Server error'
const body =
  "We're experiencing some technical issues, but our team is working on it. Try reloading the page, or check back later."
const action = 'Reload'

const ErrorPage = ({ reset }: { reset: () => void }) => {
  return (
    <main className="container">
      <ErrorContent action={action} body={body} title={title} onActionClick={reset} />
    </main>
  )
}

export default ErrorPage
